import { Helmet } from "react-helmet-async";
import TopBar from "@/components/TopBar";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import { FileText, TrendingUp, CheckCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const ServiceProAction = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>Rapports Pro Action - Agroref</title>
        <meta name="description" content="Rapports professionnels pour le suivi et l'optimisation de votre production laitière" />
      </Helmet>
      
      <TopBar />
      <NavBar />
      
      <main className="flex-1">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-primary/10 to-primary/5 py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-6">
                Rapports Pro Action
              </h1>
              <p className="text-xl text-muted-foreground">
                Des rapports détaillés et des analyses approfondies pour optimiser votre production laitière
              </p>
            </div>
          </div>
        </section>

        {/* Services Details */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="grid md:grid-cols-2 gap-8 mb-12">
                <Card>
                  <CardContent className="pt-6">
                    <FileText className="h-12 w-12 text-primary mb-4" />
                    <h3 className="text-xl font-semibold mb-3">Rapports détaillés</h3>
                    <p className="text-muted-foreground">
                      Analyses complètes de la qualité du lait et des performances de votre troupeau.
                    </p>
                  </CardContent>
                </Card>

                <Card>
                  <CardContent className="pt-6">
                    <TrendingUp className="h-12 w-12 text-primary mb-4" />
                    <h3 className="text-xl font-semibold mb-3">Optimisation continue</h3>
                    <p className="text-muted-foreground">
                      Recommandations personnalisées pour améliorer vos résultats et votre rentabilité.
                    </p>
                  </CardContent>
                </Card>
              </div>

              <div className="bg-card rounded-lg p-8 shadow-sm mb-8">
                <h2 className="text-2xl font-bold mb-6">Contenu des rapports</h2>
                <div className="space-y-4">
                  {[
                    "Analyse de la qualité du lait (CCS, bactériologie)",
                    "Suivi des performances individuelles et du troupeau",
                    "Indicateurs de santé mammaire",
                    "Conformité aux normes Pro Action",
                    "Tendances et évolution dans le temps",
                    "Recommandations d'amélioration ciblées",
                    "Comparaison avec les standards de l'industrie",
                    "Plan d'action personnalisé"
                  ].map((service, index) => (
                    <div key={index} className="flex items-start gap-3">
                      <CheckCircle className="h-6 w-6 text-primary flex-shrink-0 mt-0.5" />
                      <p className="text-muted-foreground">{service}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-primary/5 rounded-lg p-8">
                <h2 className="text-2xl font-bold mb-4">Programme Pro Action</h2>
                <p className="text-muted-foreground mb-4">
                  Le programme Pro Action des Producteurs laitiers du Canada vise à démontrer l'engagement des producteurs laitiers canadiens envers la production d'un lait de qualité supérieure, en conformité avec les normes les plus élevées.
                </p>
                <p className="text-muted-foreground">
                  Nos rapports vous aident à maintenir et améliorer votre conformité tout en optimisant vos performances.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="bg-primary/5 py-16">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold mb-4">Optimisez vos résultats</h2>
            <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
              Contactez-nous pour en savoir plus sur nos rapports Pro Action
            </p>
            <a
              href="/contact"
              className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-8 py-3 rounded-lg font-semibold hover:bg-primary/90 transition-colors"
            >
              <FileText className="h-5 w-5" />
              Nous contacter
            </a>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default ServiceProAction;
